'use client'

import { MenuActionId } from '@common/enums'

import { switchWorkspace } from '@modules/projects/utils/switchWorkspace'
import { useWorkspacesStore } from '@modules/workspaces'
import { useLayoutStore } from '@stores/layout/layout.store'

import { getRouteForWorkspaceAction } from '../utils/getRouteForWorkspaceAction'

import { useNavigateTo } from './useNavigateTo'

type UseWorkspaceSelectParams = {
  isPortal: boolean
}

export function useWorkspaceSelect({ isPortal }: UseWorkspaceSelectParams) {
  const { navigateOrRedirect } = useNavigateTo({ isPortal })

  const handleWorkspaceSelect = async (workspaceId: string) => {
    if (workspaceId === MenuActionId.INVITE_PEOPLE) {
      if (isPortal) {
        useLayoutStore.getState().openInviteWorkspaceDialog()
        return
      }

      const inviteRoute = getRouteForWorkspaceAction(workspaceId)
      if (inviteRoute) {
        return navigateOrRedirect(inviteRoute)
      }
      return
    }

    const route = getRouteForWorkspaceAction(workspaceId)
    if (route) {
      return navigateOrRedirect(route)
    }
    const workspace = useWorkspacesStore.getState().workspaces.find((w) => w.workspaceId === workspaceId)
    if (workspace) {
      await switchWorkspace(workspace)
    }
  }

  return { handleWorkspaceSelect }
}
